export const actionTabs = [
  { key: 'date', title: 'Schedule date' },
  { key: 'campaign', title: 'Generate campaign' },
  { key: 'schedule', title: 'Schedule newsletters' },
  { key: 'resend', title: 'Resend newsletters' },
];

export const RESOURCE_TYPE_ID = {
  SEND_PREVIEW: 1, // deprecated, but keeping to preserve order
  GENERATE_PREVIEW: 2,
  SEND_REMINDER: 3, // deprecated, but keeping to preserve order
  SCHEDULE_NEWSLETTER: 4,
  SEND_NEWSLETTER: 5,
  RESEND_NEWSLETTER: 6,
};



// WEBPACK FOOTER //
// ./src/helpers/constants.js